import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueI18n from 'vue-i18n';
import messages from './lang';
import CountryFlag from 'vue-country-flag'
import VueMeta from 'vue-meta'

import './../node_modules/bulma/css/bulma.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

Vue.component('country-flag', CountryFlag)
Vue.config.productionTip = false

Vue.use(VueI18n);
export const i18n = new VueI18n({
  locale: 'pt',
  fallbackLocale: 'en',
  messages
});

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: false
})

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')